<template>
    <v-tooltip location="right">
        <template #activator="{ props }">
             <v-list-item
                  link
                  style="margin-top: 1px; "
                  :to="routeTo"
                  v-bind="props"
                  :id="id"
                  :style="{ boxShadow: isActive ? '0 0 5px rgba(0, 0, 0, 0.3)' : 'none' }"
                >
                  <template #prepend>
                    <v-icon :style="{ opacity: isActive ? '1' : '0.8', width: '22px', color: 'whitesmoke' }">{{icon}}</v-icon>
                  </template>
                  <v-list-item-title style="opacity: 0.8; color: whitesmoke; font-size: 1.0em">{{name.toUpperCase()}}</v-list-item-title>
                </v-list-item>
        </template>
        <span>{{name.toUpperCase()}}</span>
    </v-tooltip>
</template>

<script>
import { getCurrentProjectId, withProjectQuery } from '@/util/projectRoute';

export default {
  name: "MainSideMenuItem",
  props: {
    'name': {required: true},
    'link': {required: true},
    'icon': {default: false},
    'id': {default: 'no-id-set'},
    'isActive': { type: Boolean, default: false }
  },
  computed: {
    routeTo() {
      return withProjectQuery(this.link, getCurrentProjectId(this.$store));
    },
  },
}
</script>

<style scoped>
</style>
